import type { ReactNode } from 'react'

export function EmptyState({
    title,
    description,
    action,
}: {
    title: string
    description?: string
    action?: ReactNode
}) {
    return (
        <div className='flex flex-col items-center justify-center gap-2 px-6 py-12 text-center'>
            <svg
                className='h-10 w-10 text-slate-300 dark:text-slate-600'
                fill='none'
                viewBox='0 0 24 24'
                stroke='currentColor'
                strokeWidth={1.5}
            >
                <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    d='20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5m6 4.125l2.25 2.25m0 0l2.25 2.25M12 13.875l2.25-2.25M12 13.875l-2.25 2.25M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z'
                />
            </svg>
            <h3 className='text-sm font-semibold text-slate-600 dark:text-slate-300'>{title}</h3>
            {description && (
                <p className='max-w-sm text-sm text-slate-500 dark:text-slate-400'>{description}</p>
            )}
            {action && <div className='mt-2'>{action}</div>}
        </div>
    )
}
